// bao migrate skip
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";

class HourBookingOverviewReportViewModel {
    constructor(parent: any) {
        this.parent = parent;
        this._initialized = false;
    }
    parent: any;
    Bao = Bao;
    private _initialized: boolean;
    ConfigurationItemId: KnockoutObservable<string> = ko.observable("");
    PersonFullName: KnockoutObservable<string> = ko.observable("");
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    Months: KnockoutObservableArray<number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<number> = ko.observable(null);
    SelectedMonth: KnockoutObservable<number> = ko.observable(null);
    Download() {
        if (this.ConfigurationItemId() == null || this.SelectedYear() == null || this.SelectedMonth() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/HourBookingOverviewReportDownload", JSON.stringify({
                personId: this.ConfigurationItemId(),
                year: this.SelectedYear(),
                month: this.SelectedMonth(),
                reportTemplateId: null
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
    init() {
        return Bao.post("SynosetReportCenter/HourBookingOverviewReportGetDefaultData", (result) => {
            ko.map.fromJS(result, this);
            this._initialized = true;
        });
    }
    ;
    loaded() {
        //Dashboard laden
        var currentDate = new Date();
    }
    ;
}
export default HourBookingOverviewReportViewModel;